import { Grid, Typography } from '@mui/material';
import { Divider } from '../../common/components/utils/textUtils';
import { NoResults } from "../../common/utils/notDataUtils"
import GroupProductsCard from "./groupProductsCard"

function GroupsCard({ subcategoryInfo, groupsData }) {
    return (
        <div className="justify-content-start">
            <Grid container alignItems="center" justifyContent="space-between">
                <h2 className="catalog-title">Modelos {subcategoryInfo.name}</h2>
            </Grid>
            {groupsData.length === 0 ? (
                <NoResults text="No se encontraron grupos para esta subcategoría" />
            ) : (
                <Grid container>
                    {groupsData.map((group) => (
                        <Grid item xs={12} key={group.code}>
                            <Divider px={1} color={"#cdcdcd"} />
                            <Grid container alignItems="center">
                                <h3>
                                    {group.name}
                                </h3>
                            </Grid>
                            <Grid container className="row">
                                <GroupProductsCard groupCode={group.code} />
                            </Grid>
                        </Grid>
                    ))}
                </Grid>
            )}
        </div>
    );
}

export default GroupsCard